
import { actions } from "./authRedux";

export const login = user => async dispatch => {
    dispatch(actions.login({ entities: user }));
}

export const logout = () => async dispatch => {
    dispatch(actions.logout());
}